export default class ShopGift {
    id = ''
    name = ''
    description = ''
    edit_url = ''
    edit_label = ''
    error = null
    products_url = ''

    constructor(gift) {
        if (gift) {
            this.id = gift.id
            this.name = gift.name
            this.description = gift.description
            this.edit_url = gift.edit_url
            this.edit_label = gift.edit_label
            this.error = gift.error
            this.products_url = gift.products_url
        }
    }
}